import React from 'react';
import LegalDocument from '../components/LegalDocument';

const REGISTERED_OFFICE = 'Registered Office: H NO 2-1-266/1/6, F NO 201, PLOT NO. 6, 2ND FLOOR, Bandlaguda, Hayathnagar, K.V. Rangareddy, Hyderabad, Telangana, 500068';

const sections = [
  {
    heading: '1. About the Company and Scope',
    content: [
      'Perfect Layout Private Limited operates a technology-enabled real estate ecosystem connecting, as applicable, customers, landowners, developers, procurement partners, sales associates and other participants in real estate transactions.',
      'The Company may provide property discovery, listing, marketing, lead management, sales support, procurement coordination, partner programmes, training, customer assistance and related technology-enabled services.',
      'The Company’s role may differ from project to project. Depending on the transaction, the Company may act as a promoter, real estate agent, intermediary, marketing/service provider, referral platform, or in another legally permitted capacity. The applicable transaction documents and disclosures will identify the relevant role.',
    ],
  },
  {
    heading: '2. Acceptance of Terms',
    content: [
      'By accessing, browsing, registering on, submitting information to, or otherwise using the platform, you confirm that you have read, understood and agreed to these Terms and any applicable project-specific, partner-specific, subscription or transaction terms.',
      'If you are using the platform on behalf of an organisation, you represent that you have authority to bind that organisation.',
    ],
  },
  {
    heading: '3. Definitions',
    content: [
      '“Platform” means the Company’s website, applications, digital interfaces, communication channels and related technology services.',
      '“Property” means any plot, land parcel, villa plot, farm land, residential or commercial property or other real estate displayed or referred to through the Platform.',
      '“Customer” means a person who enquires about, books, purchases, invests in, or otherwise engages with a Property or service.',
      '“Partner” includes procurement partners, sales associates, developers, landowners, channel partners and other authorised participants.',
      '“Transaction Documents” means booking forms, agreements for sale, sale deeds, development agreements, partner agreements, subscription agreements, invoices and other documents applicable to a specific transaction.',
    ],
  },
  {
    heading: '4. Eligibility',
    content: [
      'Users must be legally competent to enter into contracts under applicable law. Where a service or transaction requires a minimum age or other eligibility requirement, the applicable requirement will apply.',
      'Users must provide accurate and complete information and must not impersonate another person or entity.',
    ],
  },
  {
    heading: '5. Nature of Platform and Services',
    content: [
      'The Platform may contain information supplied by the Company and/or third parties such as landowners, developers, promoters, agents and service providers.',
      'Unless expressly stated in the relevant Transaction Documents, listing or displaying a Property does not by itself constitute a representation that the Company owns the Property, is the promoter of the project, or guarantees the transaction.',
      'The Company may add, modify, suspend or discontinue features or services, subject to applicable law and contractual obligations.',
    ],
  },
  {
    heading: '6. Property Listings, Prices and Information',
    content: [
      'Property descriptions, photographs, videos, maps, layouts, dimensions, availability, amenities, approvals, development timelines, prices, discounts and other information may change and may be subject to errors or omissions.',
      'Images, renderings, maps and illustrations are for representation and may not reflect exact on-site conditions.',
      'Prices and other commercial terms are indicative unless confirmed in the applicable written Transaction Documents. Applicable taxes, registration charges, stamp duty, development charges, maintenance charges, infrastructure charges, brokerage/service fees and other costs may apply.',
      'The Company does not guarantee future appreciation, resale value, rental income, demand, development completion, infrastructure delivery or any particular financial outcome.',
    ],
  },
  {
    heading: '7. RERA, Approvals and Project Compliance',
    content: [
      'Where the Real Estate (Regulation and Development) Act, 2016 (“RERA”) or other applicable law requires registration, licensing, approval or disclosure, the relevant project/agent details will be provided as applicable.',
      'Users should independently verify applicable RERA registration details, approvals, sanctioned plans, title documents and other statutory information before making a commitment.',
      'These Terms do not replace any registration, disclosure, agreement or statutory obligation required under RERA or other applicable law.',
    ],
  },
  {
    heading: '8. Customer Due Diligence',
    content: [
      'Before purchasing or booking a Property, customers should independently verify title and ownership, encumbrances, survey numbers, boundaries, land use, layout approvals, RERA registration where applicable, access roads, utilities, development status, taxes, litigation, statutory permissions and all other matters relevant to the transaction.',
      'Customers are strongly advised to inspect the Property and obtain independent legal, tax and financial advice before committing funds.',
      'Land and property values can increase or decrease and are not guaranteed by the Company.',
    ],
  },
  {
    heading: '9. Booking, Payments and Transaction Documents',
    content: [
      'A booking or transaction becomes binding only in accordance with the applicable booking form, allotment letter, agreement, sale deed or other Transaction Documents and receipt/acceptance of payment as required.',
      'Users must make payments only through authorised payment channels communicated by the Company or the relevant project/promoter.',
      'No employee, sales associate, procurement partner or other representative is authorised to collect or receive money through unauthorised personal accounts or to alter contractual terms without written authority.',
      'Taxes, registration fees, stamp duty and other statutory or transaction charges shall be borne as specified in the applicable Transaction Documents or under applicable law.',
    ],
  },
  {
    heading: '10. Cancellation and Refunds',
    content: [
      'Cancellation, refund, forfeiture, deductions, transfer and related rights will be governed by the applicable Transaction Documents, project-specific policies and mandatory provisions of applicable law.',
      'Nothing in these Terms is intended to remove or restrict a statutory right to a refund, cancellation, compensation or other remedy where such right is mandatory under applicable law.',
    ],
  },
  {
    heading: '11. Loan and Finance Support',
    content: [
      'The Company may provide information, coordination or referral assistance relating to loans or property finance. Such assistance does not constitute a guarantee of loan approval, interest rate, sanction amount, tenure or other lending terms.',
      'The relevant bank or financial institution independently determines eligibility, documentation, approval and disbursement.',
    ],
  },
  {
    heading: '12. Sales Associate Terms',
    content: [
      'Sales associates may participate as independent business partners unless a separate written employment or service agreement states otherwise.',
      'No minimum or guaranteed income, commission, incentive or sales volume is promised. Commissions, incentives and payouts are subject to the applicable written plan, successful transactions, eligibility conditions, documentation, applicable deductions and Company policy.',
      'Sales associates must not make unauthorised promises, offer unapproved discounts, misrepresent property information, collect money outside authorised processes, or bind the Company to any obligation without written authority.',
    ],
  },
  {
    heading: '13. Procurement Partner Terms',
    content: [
      'Submission of a land or property opportunity does not create an automatic right to commission, appointment or payment.',
      'All opportunities are subject to Company verification, due diligence, evaluation and approval. Procurement partner compensation, if any, will depend on the applicable policy and written agreement, including factors such as opportunity quality, information supplied and successful closure.',
      'Partners must provide accurate information, maintain confidentiality, avoid false commitments and comply with Company policies and applicable law.',
    ],
  },
  {
    heading: '14. Developer and Landowner Responsibilities',
    content: [
      'A developer, promoter or landowner listing or offering property through the Platform represents that it has the necessary authority to provide the information and participate in the transaction.',
      'Such parties are responsible for the accuracy and completeness of documents, title information, approvals, statutory compliance, disclosures and contractual obligations applicable to their Property.',
      'The Company may suspend, modify or remove a listing where information appears inaccurate, incomplete, misleading, unauthorised or non-compliant, subject to applicable contractual and legal requirements.',
    ],
  },
  {
    heading: '15. Subscriptions, Fees and Paid Services',
    content: [
      'Certain partner, listing, marketing, subscription, office/cabin, training or technology services may be offered for fees.',
      'Applicable fees, taxes, billing cycles, renewal terms, cancellation rules and service inclusions will be stated in the relevant order, invoice, subscription plan or separate agreement.',
      'A user should review those terms before purchasing a paid service.',
    ],
  },
  {
    heading: '16. Investor / Investment Disclaimer',
    content: [
      'Any website content referring to investment, ownership participation, equity participation, dividends, value appreciation, future revenue streams, expansion plans, a 2030 vision, or potential listing on NSE/BSE is provided for general informational and forward-looking purposes only.',
      'Such content is not, by itself, an offer, invitation, solicitation or recommendation to buy or subscribe to securities or any investment product.',
      'No return, dividend, appreciation, exit, liquidity or other financial outcome is guaranteed. Any actual investment or securities transaction must be undertaken only through legally compliant documentation and processes applicable to the relevant offering.',
      'Prospective investors should conduct independent due diligence and obtain independent legal, financial and tax advice before making any investment decision.',
    ],
  },
  {
    heading: '17. User Accounts and Information',
    content: [
      'Where account registration is required, users are responsible for maintaining accurate information and for keeping login credentials confidential.',
      'Users must promptly notify the Company of suspected unauthorised access or misuse. The Company may suspend access where reasonably necessary for security, compliance or protection of users and the Platform.',
    ],
  },
  {
    heading: '18. Prohibited Conduct',
    content: [
      'Users must not:',
      [
        'provide false, misleading or incomplete information;',
        'impersonate another person or entity;',
        'make unauthorised representations on behalf of the Company;',
        'upload unlawful, infringing or harmful material;',
        'misuse customer, partner or Company data;',
        'attempt unauthorised access to systems or accounts;',
        'scrape, copy or systematically extract Platform data without permission;',
        'send spam or fraudulent communications;',
        'bypass authorised transaction or payment processes;',
        'misuse Company relationships, branding or confidential information; or',
        'engage in any activity prohibited by applicable law.',
      ],
    ],
  },
  {
    heading: '19. Intellectual Property',
    content: [
      'The Company’s name, trademarks, logos, website design, text, graphics, videos, software, databases and other original content are owned by or licensed to the Company and are protected by applicable law.',
      'Users may access the Platform for lawful personal or authorised business purposes. No material may be copied, reproduced, modified, distributed, republished or commercially exploited without appropriate permission, except where permitted by law.',
      'By submitting photographs, descriptions, documents or other content to the Platform, the user grants the Company a non-exclusive licence to use such content for operating, promoting and providing the relevant service, subject to applicable law and the Privacy Policy.',
    ],
  },
  {
    heading: '20. Third-Party Services and Links',
    content: [
      'The Platform may contain links, integrations or references to third-party websites, banks, financial institutions, service providers, developers, promoters or other organisations.',
      'Third-party services are subject to their own terms and privacy policies. The Company is not responsible for third-party systems or content except to the extent required by applicable law.',
    ],
  },
  {
    heading: '21. Platform Availability and Security',
    content: [
      'The Company will take reasonable measures to maintain the Platform, but uninterrupted availability cannot be guaranteed. Access may be affected by maintenance, technical failures, telecommunications issues, cyber incidents, force majeure or events outside reasonable control.',
      'Nothing in these Terms excludes liability that cannot lawfully be excluded.',
    ],
  },
  {
    heading: '22. Privacy and Communications',
    content: [
      'Personal information will be handled in accordance with the Company’s Privacy Policy and applicable data protection law.',
      'By providing contact information, users may receive service-related calls, SMS, WhatsApp messages, emails or other communications relating to enquiries, transactions, appointments, payments, support and account activity, subject to applicable law.',
      'Marketing communications may be subject to opt-out mechanisms. Transactional and legally required communications may continue where permitted or required by law.',
    ],
  },
  {
    heading: '23. Data Protection',
    content: [
      'The Company will process personal data in accordance with applicable data protection requirements, including the Digital Personal Data Protection Act, 2023 and applicable rules and regulations as and when applicable.',
      'The Privacy Policy should explain applicable purposes of processing, categories of data, rights, grievance mechanisms, retention and other required disclosures.',
    ],
  },
  {
    heading: '24. Disclaimers',
    content: [
      'To the extent permitted by law, the Company does not guarantee:',
      [
        'appreciation or profitability of any Property;',
        'future demand, rental income or resale value;',
        'approval or sanction of loans;',
        'completion of development or infrastructure by a specified date unless contractually committed;',
        'uninterrupted Platform availability;',
        'guaranteed sales, leads, commissions or partner income; or',
        'any future corporate, expansion, revenue or stock-exchange-listing outcome described as a vision or roadmap.',
      ],
      'Mandatory statutory rights and contractual obligations are not excluded by these disclaimers.',
    ],
  },
  {
    heading: '25. Limitation of Liability',
    content: [
      'To the maximum extent permitted by applicable law, the Company will not be liable for indirect, incidental, special or consequential losses arising from use of the Platform.',
      'Any contractual limitation of liability is subject to mandatory consumer, RERA, data protection and other statutory rights and does not exclude liability for matters that cannot legally be excluded, including fraud or wilful misconduct where applicable.',
      'Where legally permissible, liability relating solely to paid Platform services may be limited to the amount actually paid for the affected service during the applicable period, subject to the relevant contract and law.',
    ],
  },
  {
    heading: '26. Indemnity',
    content: [
      'To the extent permitted by law, a user may be responsible for losses, claims, liabilities, costs or expenses arising from the user’s breach of these Terms, unlawful conduct, fraud, infringement of third-party rights, or unauthorised representations made by the user.',
      'This clause does not limit any statutory rights or remedies available to consumers or other protected persons under applicable law.',
    ],
  },
  {
    heading: '27. Suspension and Termination',
    content: [
      'The Company may suspend or terminate access to the Platform or a user account where reasonably necessary because of breach of these Terms, suspected fraud, security concerns, legal requirements, non-payment or misuse.',
      'Termination does not automatically cancel rights or obligations that have already accrued under a separate Transaction Document, unless that document or applicable law provides otherwise.',
    ],
  },
  {
    heading: '28. Force Majeure',
    content: [
      'The Company will not be responsible for delay or failure caused by events beyond reasonable control, including natural disasters, war, civil unrest, government action, strikes, major infrastructure failures, epidemics, telecommunications failures, cyber incidents or other force majeure events, subject to applicable law.',
    ],
  },
  {
    heading: '29. Governing Law and Jurisdiction',
    content: [
      'These Terms are governed by the laws of India.',
      'Subject to mandatory statutory forums and remedies available under consumer protection laws, RERA and other applicable legislation, courts/tribunals having jurisdiction at Hyderabad, Telangana may have jurisdiction over disputes arising from these Terms.',
    ],
  },
  {
    heading: '30. Dispute Resolution',
    content: [
      'The parties should first attempt in good faith to resolve a dispute through written communication with the Company.',
      'Where a separate written agreement contains an arbitration or dispute-resolution clause, that clause will apply to the extent legally enforceable.',
      'Nothing in these Terms prevents a consumer or other entitled person from approaching a forum, authority or regulator where such remedy is provided by mandatory law.',
    ],
  },
  {
    heading: '31. Changes to These Terms',
    content: [
      'The Company may update these Terms from time to time. The latest version will be published on the Platform with an updated effective or revision date.',
      'Where applicable law requires notice or consent for a material change, the Company will follow the required process.',
    ],
  },
  {
    heading: '32. Severability, Waiver and Assignment',
    content: [
      'If any provision of these Terms is held invalid or unenforceable, the remaining provisions will continue to the extent permitted by law.',
      'Failure to enforce a provision does not constitute a permanent waiver.',
      'The Company may assign or transfer its rights and obligations as part of a lawful restructuring, merger, sale or business transfer, subject to applicable law and contractual requirements.',
    ],
  },
  {
    heading: '33. Notices and Grievance Contact',
    content: [
      'For notices, complaints and grievances, users may contact:',
      {
        lines: [
          'Perfect Layout Private Limited',
          REGISTERED_OFFICE,
          'Email: care@perfectlayout.in',
          'Phone: +91 9951164521',
          'Grievance Officer: Laxmi Veeresh Marthi',
        ],
      },
      'The Company will handle grievances in accordance with applicable law and its internal grievance process.',
    ],
  },
  {
    heading: '34. Contact Details',
    content: [
      {
        lines: [
          'Website: www.perfectlayout.in',
          'Email: care@perfectlayout.in',
          'Phone: +91 9951164521',
          'Location: 2-1-282, Plot No.83, Road No.7, Mamatha Nagar, Nagole, Hyderabad – 500068',
          REGISTERED_OFFICE,
          'CIN: U68100TS2023PTC175927',
          'GSTIN: 36AANCP9940Q1ZB',
        ],
      },
    ],
  },
];

const TermsConditions = () => (
  <LegalDocument
    title="Terms & Conditions / Terms of Use"
    lastUpdated="September 29, 2026"
    intro="These Terms & Conditions / Terms of Use (“Terms”) govern access to and use of the website, digital platforms, property listings, partner programmes and related services operated by Perfect Layout Private Limited (“Company”, “we”, “us” or “our”). By accessing or using the platform, you agree to these Terms. If you do not agree, please do not use the platform."
    sections={sections}
  />
);

export default TermsConditions;
